export const cartRequest = ({
    size,
    quantity,
    product
} = {}) => ({
    size,
    quantity,
    product
})